export default __webpack_public_path__ + "static/m-colombians-abroad-9b6d8c8dcc637d43da4d5b76a5564e9c.png";